import * as React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import { Button } from "src/library/components/Button";
import { IDrop } from "src/core/drops/api/drops.api";
import { useDrop } from "src/core/drops/hooks";

interface QuickAssignCurrentDropProps {
    assignToCard: (drop: IDrop) => void;
    loading: boolean;
}

export const QuickAssignCurrentDrop: React.ReactFCWithChildren<QuickAssignCurrentDropProps> = ({ assignToCard, loading }) => {
  const [ { drop } ] = useDrop();

  if (!drop || drop.defaultPaymentCardId) {
    return null;
  }

  return (
    <QuickAssignCurrentDropWrapper>
      <div>
        <Text>
          Current drop:
        </Text>

        <br />

        <Text
          weight="bold"
          className="drop-name"
        >
          {drop.name}
        </Text>
      </div>

      <div>
        <Button
          onClick={() => assignToCard(drop)}
          loading={loading}
        >
          Assign
        </Button>
      </div>
    </QuickAssignCurrentDropWrapper>
  );
};

const QuickAssignCurrentDropWrapper = styled.div`
${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    border: 2px solid ${theme.colors.lightGrey};
    border-radius: ${theme.borderRadius};
    padding: ${theme.spacing.padding.md};
    width: 50%;
    margin-bottom: ${theme.spacing.margins.md};
    background: ${theme.colors.white};
  `}
`;
